import axiosInst from '../../libs/axios/axios'

const state = {
  rootUrl: process.env.VUE_APP_ROOT_URL,
  timeOut: process.env.VUE_APP_TIME_OUT,
  rulesData: {}
}
const getters = {
  returnRulesData (state) {
    return state.rulesData
  }
}
const mutations = {
  rulesData (state, info) {
    state.rulesData = info
  }
}
const actions = {
  getRulesList (store) {
    return new Promise((resolve, reject) => {
      axiosInst.get(`${state.rootUrl  }/api/rules/`)
        .then(response => {
          const rulesData = []
          if (response.data.length) {
            response.data.map((value) => {
              rulesData.push({
                'id': value.id,
                'rule_name': value.name,
                'total_apiary_count': value.total_apiary_count,
                'rule_sets': value.rule_sets,
                'operation': value.operation,
                'email_notification': value.email_notification,
                'platform_notification': value.platform_notification,
                'sms_notification': value.sms_notification
              })
            })
          }
          store.commit('rulesData', rulesData)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getRule (store, data) {
    return new Promise((resolve, reject) => {
      axiosInst.get(`${state.rootUrl  }/api/rules/${  data.id  }/`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  createRule (store, data) {
    return new Promise((resolve, reject) => {
      axiosInst.post(`${state.rootUrl  }/api/rules/`, data.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  ruleAttach (store, data) {
    return new Promise((resolve, reject) => {
      axiosInst.put(`${state.rootUrl  }/api/rules/${data.id }/attach/`, data.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  editRule (store, data) {
    return new Promise((resolve, reject) => {
      axiosInst.put(`${state.rootUrl  }/api/rules/${data.id}/`, data.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteRule (store, data) {
    return new Promise((resolve, reject) => {
      axiosInst.delete(`${state.rootUrl  }/api/rules/${  data.id}/`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getRuleApiaryList () {
    return new Promise((resolve, reject) => {
      axiosInst.get(`${state.rootUrl  }/api/apiary/rule/available/`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
